import { c as _c } from "react-compiler-runtime";
import * as React from "react";
import { Focusable, Group, Link, Pressable, Text } from "react-aria-components";
import { icon } from "../icon.css.js";
import { User01 } from "../icons/line.js";
import { abbreviateName } from "../utils/name.js";
import useTextFit from "../utils/useTextFit.js";
import { avatarImage, baseAvatarStyle, placeholderTextStyle } from "./Avatar.css.js";
import { Tooltip } from "./Tooltip.js";
import { jsx as _jsx } from "react/jsx-runtime";
const AutoTextFit = t0 => {
  const $ = _c(9);
  const {
    size,
    children
  } = t0;
  const {
    textRef,
    containerRef
  } = useTextFit(children, 6, 16, 10, 0.5);
  let t1;
  if ($[0] !== size) {
    t1 = placeholderTextStyle({
      size
    });
    $[0] = size;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== textRef) {
    t2 = /*#__PURE__*/_jsx("span", {
      ref: textRef,
      children: children
    });
    $[2] = children;
    $[3] = textRef;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== containerRef || $[6] !== t1 || $[7] !== t2) {
    t3 = /*#__PURE__*/_jsx(Text, {
      ref: containerRef,
      className: t1,
      children: t2
    });
    $[5] = containerRef;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
const defaultSize = "m";
const BaseAvatarImage = (t0, ref) => {
  const $ = _c(24);
  const {
    children,
    size: t1,
    isIcon: t2,
    href,
    onPress,
    active,
    isInteractive
  } = t0;
  const size = t1 === undefined ? defaultSize : t1;
  const isIcon = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== active || $[1] !== isIcon || $[2] !== isInteractive || $[3] !== size) {
    t3 = baseAvatarStyle({
      size,
      isIcon,
      isInteractive,
      active
    });
    $[0] = active;
    $[1] = isIcon;
    $[2] = isInteractive;
    $[3] = size;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const className = t3;
  if (href != null) {
    const t4 = ref;
    let t5;
    if ($[5] !== children || $[6] !== className || $[7] !== href || $[8] !== onPress || $[9] !== t4) {
      t5 = /*#__PURE__*/_jsx(Link, {
        ref: t4,
        onPress: onPress,
        href: href,
        className: className,
        children: children
      });
      $[5] = children;
      $[6] = className;
      $[7] = href;
      $[8] = onPress;
      $[9] = t4;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    return t5;
  }
  if (onPress == null) {
    const t4 = ref;
    let t5;
    if ($[11] !== children || $[12] !== className) {
      t5 = /*#__PURE__*/_jsx("div", {
        role: "treeitem",
        className: className,
        children: children
      });
      $[11] = children;
      $[12] = className;
      $[13] = t5;
    } else {
      t5 = $[13];
    }
    let t6;
    if ($[14] !== t4 || $[15] !== t5) {
      t6 = /*#__PURE__*/_jsx(Focusable, {
        ref: t4,
        children: t5
      });
      $[14] = t4;
      $[15] = t5;
      $[16] = t6;
    } else {
      t6 = $[16];
    }
    return t6;
  }
  const t4 = ref;
  let t5;
  if ($[17] !== children || $[18] !== className) {
    t5 = /*#__PURE__*/_jsx("div", {
      role: "treeitem",
      className: className,
      children: children
    });
    $[17] = children;
    $[18] = className;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  let t6;
  if ($[20] !== onPress || $[21] !== t4 || $[22] !== t5) {
    t6 = /*#__PURE__*/_jsx(Pressable, {
      ref: t4,
      onPress: onPress,
      children: t5
    });
    $[20] = onPress;
    $[21] = t4;
    $[22] = t5;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  return t6;
};
const AvatarImage = /*#__PURE__*/React.forwardRef(BaseAvatarImage);
const BaseAvatarTooltip = (t0, ref) => {
  const $ = _c(14);
  let children;
  let isIcon;
  let props;
  let t1;
  let tooltip;
  if ($[0] !== t0) {
    ({
      children,
      tooltip,
      name: t1,
      isIcon,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = isIcon;
    $[3] = props;
    $[4] = t1;
    $[5] = tooltip;
  } else {
    children = $[1];
    isIcon = $[2];
    props = $[3];
    t1 = $[4];
    tooltip = $[5];
  }
  const name = t1 === undefined ? "" : t1;
  const text = typeof tooltip === "string" ? tooltip : name;
  let t2;
  if ($[6] !== children || $[7] !== isIcon || $[8] !== props || $[9] !== ref) {
    t2 = /*#__PURE__*/_jsx(AvatarImage, {
      ...props,
      ref: ref,
      isIcon: isIcon,
      children: children
    });
    $[6] = children;
    $[7] = isIcon;
    $[8] = props;
    $[9] = ref;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  const avatarImage = t2;
  if (tooltip === false || text.length === 0) {
    return avatarImage;
  }
  let t3;
  if ($[11] !== avatarImage || $[12] !== text) {
    t3 = /*#__PURE__*/_jsx(Tooltip, {
      text: text,
      theme: "dark",
      arrow: true,
      children: avatarImage
    });
    $[11] = avatarImage;
    $[12] = text;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
};
const AvatarTooltip = /*#__PURE__*/React.forwardRef(BaseAvatarTooltip);

// `fetchPriority` is only supported as React prop in v18+, so we're doing lowercase: https://github.com/facebook/react/pull/25927
const fetchPriorityProps = React.version.startsWith("17") ? {
  fetchpriority: "high"
} : {
  fetchPriority: "high"
};
const iconSizeMapping = {
  xxs: "s",
  xs: "s",
  s: "m",
  m: "l",
  l: "l",
  xl: "l",
  xxl: "l"
};
const BaseAvatar = (t0, ref) => {
  const $ = _c(53);
  let Icon;
  let alt;
  let isInteractive;
  let props;
  let src;
  let t1;
  if ($[0] !== t0) {
    ({
      src,
      size: t1,
      alt,
      icon: Icon,
      isInteractive,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = Icon;
    $[2] = alt;
    $[3] = isInteractive;
    $[4] = props;
    $[5] = src;
    $[6] = t1;
  } else {
    Icon = $[1];
    alt = $[2];
    isInteractive = $[3];
    props = $[4];
    src = $[5];
    t1 = $[6];
  }
  const size = t1 === undefined ? defaultSize : t1;
  isInteractive = isInteractive ?? (props.href != null || props.onPress != null);
  if (src != null) {
    let t2;
    if ($[7] !== alt || $[8] !== src) {
      t2 = /*#__PURE__*/_jsx("img", {
        className: avatarImage,
        src: src,
        alt: alt,
        ...fetchPriorityProps
      });
      $[7] = alt;
      $[8] = src;
      $[9] = t2;
    } else {
      t2 = $[9];
    }
    let t3;
    if ($[10] !== isInteractive || $[11] !== props || $[12] !== ref || $[13] !== size || $[14] !== t2) {
      t3 = /*#__PURE__*/_jsx(AvatarTooltip, {
        ref: ref,
        ...props,
        size: size,
        isInteractive: isInteractive,
        children: t2
      });
      $[10] = isInteractive;
      $[11] = props;
      $[12] = ref;
      $[13] = size;
      $[14] = t2;
      $[15] = t3;
    } else {
      t3 = $[15];
    }
    return t3;
  }
  if (Icon != null) {
    const t2 = props;
    const t3 = isInteractive;
    const T0 = Icon;
    const t4 = iconSizeMapping[size];
    let t5;
    if ($[16] !== t4) {
      t5 = icon({
        size: t4
      });
      $[16] = t4;
      $[17] = t5;
    } else {
      t5 = $[17];
    }
    let t6;
    if ($[18] !== Icon || $[19] !== alt || $[20] !== t5) {
      t6 = /*#__PURE__*/_jsx(T0, {
        className: t5,
        "aria-label": alt
      });
      $[18] = Icon;
      $[19] = alt;
      $[20] = t5;
      $[21] = t6;
    } else {
      t6 = $[21];
    }
    let t7;
    if ($[22] !== isInteractive || $[23] !== props || $[24] !== ref || $[25] !== size || $[26] !== t6) {
      t7 = /*#__PURE__*/_jsx(AvatarTooltip, {
        ref: ref,
        ...t2,
        size: size,
        isInteractive: t3,
        isIcon: true,
        children: t6
      });
      $[22] = isInteractive;
      $[23] = props;
      $[24] = ref;
      $[25] = size;
      $[26] = t6;
      $[27] = t7;
    } else {
      t7 = $[27];
    }
    return t7;
  }
  if (props.name != null) {
    const t2 = props;
    const t3 = isInteractive;
    let t4;
    if ($[28] !== size) {
      t4 = placeholderTextStyle({
        size
      });
      $[28] = size;
      $[29] = t4;
    } else {
      t4 = $[29];
    }
    const t5 = alt;
    let t6;
    if ($[30] !== props.name) {
      t6 = abbreviateName(props.name);
      $[30] = props.name;
      $[31] = t6;
    } else {
      t6 = $[31];
    }
    let t7;
    if ($[32] !== alt || $[33] !== t4 || $[34] !== t6) {
      t7 = /*#__PURE__*/_jsx("div", {
        className: t4,
        "aria-label": t5,
        children: t6
      });
      $[32] = alt;
      $[33] = t4;
      $[34] = t6;
      $[35] = t7;
    } else {
      t7 = $[35];
    }
    let t8;
    if ($[36] !== isInteractive || $[37] !== props || $[38] !== ref || $[39] !== size || $[40] !== t7) {
      t8 = /*#__PURE__*/_jsx(AvatarTooltip, {
        ref: ref,
        ...t2,
        size: size,
        isInteractive: t3,
        children: t7
      });
      $[36] = isInteractive;
      $[37] = props;
      $[38] = ref;
      $[39] = size;
      $[40] = t7;
      $[41] = t8;
    } else {
      t8 = $[41];
    }
    return t8;
  }
  const t2 = props;
  const t3 = isInteractive;
  const t4 = iconSizeMapping[size];
  let t5;
  if ($[42] !== t4) {
    t5 = icon({
      size: t4
    });
    $[42] = t4;
    $[43] = t5;
  } else {
    t5 = $[43];
  }
  let t6;
  if ($[44] !== alt || $[45] !== t5) {
    t6 = /*#__PURE__*/_jsx(User01, {
      className: t5,
      "aria-label": alt
    });
    $[44] = alt;
    $[45] = t5;
    $[46] = t6;
  } else {
    t6 = $[46];
  }
  let t7;
  if ($[47] !== isInteractive || $[48] !== props || $[49] !== ref || $[50] !== size || $[51] !== t6) {
    t7 = /*#__PURE__*/_jsx(AvatarImage, {
      ref: ref,
      ...t2,
      size: size,
      isInteractive: t3,
      isIcon: true,
      children: t6
    });
    $[47] = isInteractive;
    $[48] = props;
    $[49] = ref;
    $[50] = size;
    $[51] = t6;
    $[52] = t7;
  } else {
    t7 = $[52];
  }
  return t7;
};
export const Avatar = /*#__PURE__*/React.forwardRef(BaseAvatar);
export const Counter = t0 => {
  const $ = _c(11);
  const {
    size,
    tooltip,
    count
  } = t0;
  let t1;
  if ($[0] !== size) {
    t1 = baseAvatarStyle({
      size
    });
    $[0] = size;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = count > 99 ? "99+" : `+${count}`;
  let t3;
  if ($[2] !== size || $[3] !== t2) {
    t3 = /*#__PURE__*/_jsx(AutoTextFit, {
      size: size,
      children: t2
    });
    $[2] = size;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t1 || $[6] !== t3) {
    t4 = /*#__PURE__*/_jsx(Group, {
      className: t1,
      children: t3
    });
    $[5] = t1;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const counter = t4;
  if (typeof tooltip === "string") {
    let t5;
    if ($[8] !== counter || $[9] !== tooltip) {
      t5 = /*#__PURE__*/_jsx(Tooltip, {
        text: tooltip,
        theme: "dark",
        arrow: true,
        children: counter
      });
      $[8] = counter;
      $[9] = tooltip;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    return t5;
  }
  return counter;
};
//# sourceMappingURL=Avatar.js.map